<template>
  <AppAlert variant="warning">
    Please check the connection status of Google accounts. Disabled Google APIs may prevent locations from syncing.
    <a :href="data.accountsUrl">Click to see details</a>
  </AppAlert>
</template>

<script setup>
import { AppAlert } from '@/components/ui'

defineProps({
  data: { type: Object, required: true }
})
</script>
